export default "__VITE_ASSET__8449439e__"